module.exports = __webpack_public_path__ + "img/logo.a2ec24e3.svg";